//client/src/services/returnSummary.ts
export type ReturnSummaryResponse = {
  returnId: string;
  encoding: string;
  xml: string;
  fetchedAt: string;
};

export async function fetchReturnSummaryXml(returnId: string): Promise<ReturnSummaryResponse> {
  const url = `/api/return-summary?returnId=${encodeURIComponent(returnId)}`;

  const resp = await fetch(url, {
    method: 'GET',
    cache: 'no-store',
    credentials: 'include',
  });

  if (!resp.ok) {
    const text = await resp.text().catch(() => '');
    throw new Error(`Failed to load return summary (HTTP ${resp.status}). ${text}`);
  }

  const json = (await resp.json()) as ReturnSummaryResponse;
  if (!json?.xml) throw new Error('Return summary response missing xml.');
  return json;
}

export type ReturnInUseStatus = { inUse: boolean; lastUpdatedBy: string };

export async function fetchReturnInUse(returnId: string): Promise<ReturnInUseStatus> {
  const resp = await fetch(`/api/return-in-use?returnId=${encodeURIComponent(returnId)}`, {
    method: 'GET',
    cache: 'no-store',
    credentials: 'include',
  });
  if (!resp.ok) {
    const text = await resp.text().catch(() => '');
    throw new Error(`Failed to fetch in-use status (HTTP ${resp.status}). ${text}`);
  }
  return resp.json() as Promise<ReturnInUseStatus>;
}

export async function fetchReturnLockStatus(returnId: string): Promise<boolean> {
  const resp = await fetch(`/api/return-lock-status?returnId=${encodeURIComponent(returnId)}`, {
    method: 'GET',
    cache: 'no-store',
    credentials: 'include',
  });
  if (!resp.ok) {
    const text = await resp.text().catch(() => '');
    throw new Error(`Failed to fetch lock status (HTTP ${resp.status}). ${text}`);
  }
  const data = (await resp.json()) as { locked: boolean };
  return data.locked;
}
